import posthog from "posthog-js";
import { axiosBasic, getUserInfo } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { actionTypes } from "./companyActionTypes";
const { Company } = config.REST_API;

export const loading = (value) => {
  return { type: actionTypes.LOADING, value };
};
export const setSelectedCompany = (value) => {
  return { type: actionTypes.SET_SELECTED_COMPANY, value };
};
export const clearSelectedCompanp = () => {
  return { type: actionTypes.CLEAR_SELECTED_COMPANY };
};
export const setCompanies = (companies) => {
  return { type: actionTypes.SET_COMPANIES, companies };
};
export const clearCmpErrors = () => {
  return { type: actionTypes.CLEAR_COMPANY_ERRORS };
};
export const getAllCompanies = () => {
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    dispatch(loading(true));
    return axiosBasic
      .get(Company.Get)
      .then((response) => {
        dispatch(loading(false));
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("getAllCompanies", { type: "info", userId, success: true });
        }
        let res = response.data;
        return res;
      })
      .catch((error) => {
        dispatch(loading(false));
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("getAllCompanies", {
            type: "exception",
            userId,
            success: false,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        return error;
      });
  };
};
export const addCompany = (company) => {
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    return axiosBasic
      .post(Company.Create, company)
      .then((response) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("addCompany", { type: "info", userId, success: true });
        }
        let res = response.data;
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("addCompany", {
            type: "exception",
            userId,
            success: false,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        return error;
      });
  };
};
